import {
    SET_SELECTROWKEYS,
} from '../actions/selectedRowKey';

const selectedRowKey = (state = [], action) => {
    switch (action.type) {
        case SET_SELECTROWKEYS:
            return state=action.rowRecord;
        default:
            return state;
    }
};

export default selectedRowKey;


// WEBPACK FOOTER //
// ./src/redux/reducers/selectedRowKey.js